
import {defineComponent} from 'vue';
import Input from '@ohrm/oxd/core/components/Input/Input.vue';

export default defineComponent({
  name: 'oxd-password-input',

  components: {
    'oxd-input': Input,
  },
});
